import { isPlatformError } from '@unified-dashboard/types';
/**
 * Thrown by `getJson` / `postJson` when the response is not 2xx.
 *
 * Carries the parsed body (best-effort) and, when the body matches RFC 9457
 * problem details, a typed `problem` projection.
 */
export class HttpError extends Error {
    status;
    body;
    problem;
    constructor(status, message, body) {
        super(message);
        this.name = 'HttpError';
        this.status = status;
        this.body = body;
        if (isPlatformError(body)) {
            this.problem = body;
        }
    }
}
/**
 * Thrown by `httpClient` when the per-route circuit breaker is open.
 *
 * Carries the route key and how long until the breaker is allowed to
 * half-open, so callers can surface a meaningful retry hint to the user.
 */
export class BreakerOpenError extends Error {
    route;
    retryAfterMs;
    constructor(route, retryAfterMs) {
        super(`Circuit breaker open for ${route} (retry in ${retryAfterMs}ms)`);
        this.name = 'BreakerOpenError';
        this.route = route;
        this.retryAfterMs = retryAfterMs;
    }
}
/**
 * Thrown when a request exceeds its `timeoutMs` budget.
 *
 * Distinguished from a caller-initiated `AbortError`: caller aborts propagate
 * as `AbortError`, time-budget aborts are surfaced as `TimeoutError` so the
 * retry policy and the breaker can treat them as transient service failures.
 */
export class TimeoutError extends Error {
    timeoutMs;
    constructor(timeoutMs) {
        super(`Request timed out after ${timeoutMs}ms`);
        this.name = 'TimeoutError';
        this.timeoutMs = timeoutMs;
    }
}
//# sourceMappingURL=error.js.map